import api from "../apis/selectree_api";
import { getAuthHeader } from "../utilities/header";

export const uploadImageToS3 = async (imageFile, folder = "uploads") => {
  try {
    const formData = new FormData();
    formData.append("image", imageFile);

    const response = await api.post(
      `/s3/upload-s3-image${folder ? `?folder=${folder}` : ""}`,
      formData,
      {
        headers: {
          ...getAuthHeader().headers,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || "Upload failed");
    }
  } catch (error) {
    console.error(`Error uploading image to S3: ${error}`);
    throw error;
  }
};
